import { isValid } from "./cvvValidator";
import { fieldValidationAction } from "../../actions";
import { notifyCard, notifyParent } from "../iframeNotifications";
import { SET_CARD_SCHEME_ACTION } from "../../constants";
import { AMEX_NAMES } from "../constants";

const MAX_LENGTH = 4;
let scheme: string | undefined;

const isAmex = (scheme?: string) =>
  AMEX_NAMES.includes((scheme || "").toLowerCase());

export const onCvvChange = (event: Event) => {
  const cvvValue = (event.target as HTMLInputElement).value;
  const isCvvValid = isValid(cvvValue, isAmex(scheme));

  notifyCard({ cvv: isCvvValid ? cvvValue : undefined });
};

const digitsRegexp = /^\d$/;
export const onCvvKeyDown = (event: KeyboardEvent) => {
  const cvvField = event.target as HTMLInputElement;
  const cvvValue = cvvField.value;
  const isFilled = cvvValue.length === MAX_LENGTH;
  const isDigitKey = digitsRegexp.test(event.key);
  const isMetaKey =
    event.ctrlKey || event.metaKey || event.shiftKey || event.key.length > 1;

  if (!isDigitKey && !isMetaKey) {
    event.preventDefault();
    return false;
  }

  if (
    isDigitKey &&
    isFilled &&
    cvvField.selectionStart === cvvField.selectionEnd // has no selection
  ) {
    event.preventDefault();
    return false;
  }
};

const nonDigitsRegexp = /(\D)/g;
export const castToCvvValue = (value: string) => {
  const newValue = value.replaceAll(nonDigitsRegexp, "");

  return newValue.substring(0, MAX_LENGTH);
};

export const onCvvInput = (event: Event) => {
  const cvvField = event.target as HTMLInputElement;

  const cvvValue = castToCvvValue(cvvField.value);
  cvvField.value = cvvValue;

  const isCvvValid = isValid(cvvValue, isAmex(scheme));
  notifyParent(fieldValidationAction({ field: "cvv", isValid: isCvvValid }));
};

export const onCardSchemaChange = (
  event: MessageEvent<{ type: string; data: string | undefined }>
) => {
  const {
    source,
    data: { type, data },
  } = event;

  if (source !== parent) {
    return;
  }

  if (type !== SET_CARD_SCHEME_ACTION) {
    return;
  }

  scheme = data;
};
